<template>
  <div class="content md no-padding flex-box vertical">
    <div class="area vertical">
      <RoleForm ref="editForm" :initial="initial" class="area-content"></RoleForm>
    </div>
    <a-space class="footer">
      <a-button @click="handleCancel">取消</a-button>
      <a-button type="primary" @click="handleSave">保存</a-button>
    </a-space>
  </div>
</template>

<script>
import RoleForm from "./components/RoleForm.vue";

export default {
  name: "RoleDetail",
  components: {
    RoleForm,
  },
  data() {
    return {
      initial: null,
    };
  },
  computed: {
    id() {
      return this.$route.params.id;
    },
  },
  created() {
    this.getDetail();
  },
  methods: {
    getDetail() {
      if (this.id) {
        this.$axios({
          url: `/admin/data-role/${this.id}`,
          method: "GET",
          params: {
            expand: "table",
          },
        }).then((res) => {
          this.initial = res;
        });
      }
    },
    handleSave() {
      this.$refs.editForm.validate().then((form) => {
        this.$axios({
          url: `/admin/data-role/${this.id}`,
          method: "PATCH",
          data: form,
        }).then(() => {
          this.$message.success("保存成功");
          this.getDetail();
          this.handleCancel();
        });
      });
    },
    handleCancel() {
      this.$router.back();
    },
  },
};
</script>

<style lang="less" scoped>
.footer {
  width: 100%;
}
.mb-24 {
  margin-bottom: 24px;
}
</style>
